import { FaCheck } from 'react-icons/fa';
import ContentImg from 'assets/images/what-we-do.png';
import useTranslation from 'hooks/useTranslation';

const WhatWeDo = () => {
  const translation = useTranslation();

  return (
    <div className="flex flex-col py-20 px-4 lg:flex-row lg:items-center lg:justify-between lg:px-[147px] lg:py-[140px]">
      <div className="lg:max-w-[558px]">
        <p className="text-xs font-bold uppercase tracking-wide text-primary-light-blue">
          {translation.whatWeDo}
        </p>
        <p className="mt-3 text-2xl font-bold text-primary-blue lg:mt-4 lg:text-[34px] lg:leading-[46px]">
          {translation.professionalAndEffective}
        </p>
        <p className="mt-3 text-sm font-normal tracking-wide text-primary-grey lg:mt-4 lg:text-base">
          {translation.weLikeToKeepThings}
        </p>

        <div className="mt-6 flex flex-col lg:mt-8 lg:max-w-[90%] lg:flex-row lg:justify-between">
          <div className="flex items-center">
            <FaCheck className="h-4 w-4 text-primary-light-blue" />
            <p className="ml-3 text-base text-primary-blue">
              {translation.reliableHosting}
            </p>
          </div>
          <div className="mt-3 flex items-center lg:mt-0">
            <FaCheck className="h-4 w-4 text-primary-light-blue" />
            <p className="ml-3 text-base text-primary-blue">
              {translation.fullyResponsive}
            </p>
          </div>
          <div className="mt-3 flex items-center lg:mt-0">
            <FaCheck className="h-4 w-4 text-primary-light-blue" />
            <p className="ml-3 text-base text-primary-blue">
              {translation.userFriendly}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-[60px] lg:mt-0">
        <img
          alt=""
          src={ContentImg}
          className="w-full lg:h-[324px] lg:w-[517px]"
        />
      </div>
    </div>
  );
};

export default WhatWeDo;
